// extracted by mini-css-extract-plugin
export var banner = "_in-0";
export var closeButton = "_in-2";
export var greenCheckmark = "_in-3";
export var hereLink = "_in-4";
export var titleIcon = "_in-1";